import { createBrowserRouter, Outlet } from 'react-router-dom';

// project imports
import { AuthProvider } from 'contexts/AuthContext';
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const AuthRoot = () => (
  <AuthProvider>
    <Outlet />
  </AuthProvider>
);

const appBaseName = import.meta.env.VITE_APP_BASE_NAME || '/';
const normalizedBaseName = appBaseName === '/' ? '/' : `/${appBaseName.replace(/^\/+|\/+$/g, '')}`;

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <AuthRoot />,
      children: [MainRoutes, LoginRoutes]
    }
  ],
  { basename: normalizedBaseName }
);

export default router;
